// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__uBLEe","search":"Settings_search__1AMrb","filter":"Settings_filter__fAlcy"};